import React from 'react';
import { createRoot } from 'react-dom/client';
import { PrimeReactProvider } from 'primereact/api';

// PrimeReact theme + utilities (same design system as the staff app)
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
// Inter, self-hosted — the staff app's typeface (frontend/src/App.js). The
// dashboard opts into it in the STAFF PARITY block of theme.css.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './app/theme.css';

import App from './app/App';

// PrimeReact 10 reads its config from PrimeReactContext. WITHOUT this provider that
// context is `undefined`, and most components tolerate it only because they guard —
// e.g. hooks.cjs.js does `context ? context.hideOverlaysOnDocumentScrolling : …`.
// Menu's own overlay listener does NOT guard (menu.cjs.js:300 reads the property
// straight off `context`), so scrolling or clicking away with the account menu open
// threw "Cannot read properties of undefined". The app had been getting away with it
// because nothing here used a popup overlay until that menu was added.
//
// Mirrors frontend/src/index.js so the two apps behave identically — including the
// z-index ladder, which is what keeps an overlay inside a modal (the offers
// comparison in a Dialog) from rendering underneath it.
const primeReactConfig = {
  ripple: true,
  inputStyle: 'outlined',
  hideOverlaysOnDocumentScrolling: false,
  zIndex: {
    modal: 1100,
    overlay: 1200,
    menu: 1300,
    tooltip: 1400,
    toast: 1500,
  },
};

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <PrimeReactProvider value={primeReactConfig}>
      <App />
    </PrimeReactProvider>
  </React.StrictMode>
);
